import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { isNumeric } from "@coworker/app/src/helpers/utils";
import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import {
  fetchAPI,
  TASKS_SERVICE_URL,
} from "@coworker/app/src/hooks/API/tasks.service.helper";
import { isEmpty } from "@coworker/apprestructured/src/shared/helpers/string.helper";
import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";

export async function fetchItemInfoAndPriceSR(
  itemNo: string
): Promise<Item | null> {
  if (!isNumeric(itemNo)) {
    reportMessageToSentry(
      `Getting item-info-price-sr called with a none numeric itemNo: ${itemNo}`,
      {
        level: "warning",
        extra: {
          itemNo: itemNo,
        },
      }
    );
    return null;
  }
  const url = `${TASKS_SERVICE_URL}/items/item-info-price-sr?itemNo=${itemNo}`;
  const { result: itemInfo } = await fetchAPI("GET", url);
  return itemInfo && !isEmpty(itemInfo)
    ? ({
        ...itemInfo,
        noFormatted: formatProductIdWithDots(itemInfo?.no),
      } as Item)
    : null;
}
